/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_ExistsInputs */



/**
* | output |
* | --- |
* | "Email already exists in user group." |
*
* @param {Team_Manager_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_exists = /** @type {((inputs?: Team_Manager_Email_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L’e-mail existe déjà dans le groupe d’utilisateurs.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die E-Mail-Adresse ist bereits in der Benutzergruppe vorhanden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'email esiste già nel gruppo utenti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Адрес электронной почты уже существует в группе пользователей.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El correo electrónico ya existe en el grupo de usuarios.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户组中已存在该电子邮件地址。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー グループに電子メールが既に存在します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता समूह में ईमेल पहले से मौजूद है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O e-mail já existe no grupo de usuários.")
	return /** @type {LocalizedString} */ ("Email already exists in user group.")
});